import React from 'react';

import { ElementCategoryID } from '@shared/models/element-categories.model';

import { ICategoryGroup } from '../../hooks/use-grouped-element-categories.hook';
import { CategoryType } from '@shared/helpers/element-category.helpers';
import { Menu, MenuWidth } from '@ui/menus/Menu';
import { ElementCategoryMenuContent } from './ElementCategoryMenuContent';

type ElementCategoryMenuProps = {
  anchor: HTMLElement | null;
  selectedCategoryId?: ElementCategoryID;
  categoryGroups: ICategoryGroup<{
    disabled: false | string;
    type: CategoryType;
  }>[];
  onSelect: (categoryId: ElementCategoryID) => void;
  onClose: () => void;
  width?: MenuWidth;
};

export const ElementCategoryMenu: React.FC<ElementCategoryMenuProps> = ({
  anchor,
  selectedCategoryId,
  categoryGroups,
  onSelect,
  onClose,
  width,
}) => {
  const isOpen = anchor !== null;

  return (
    <Menu open={isOpen} anchorEl={anchor} onClose={onClose} width={width}>
      <ElementCategoryMenuContent
        categoryGroups={categoryGroups}
        selectedCategoryId={selectedCategoryId}
        onSelect={onSelect}
      />
    </Menu>
  );
};
